import { CHAT_INPUT_MODES, useDetectIframe } from '@guuru/chat-web';

const useHideMessageBar = (isUser, isFinished, partnerId, inputMode) => {
  const inIframe = useDetectIframe();

  if (inputMode === CHAT_INPUT_MODES.none) {
    return true;
  }

  return isUser && isFinished && partnerId === 'olx-ua' && !inIframe;
};

export default useHideMessageBar;
